module.exports = __webpack_public_path__ + "img/McD_Unternehmen_Content_images_02.a9ccb21a.jpg";